import React, { useCallback, useEffect, useState } from "react";
import OrderDetailsItems from "../Items/OrderDetailsItems";
import Pagination from "../form/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../form/Button";
import Input from "../form/Input";

const MyCurrentOrdersDetails = ({ data, title }) => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const itemsPerPage = 2;
  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`?page=${page}`);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const currentItems = data?.slice(startIndex, endIndex);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = params.get("page");
    if (pageParam) {
      setCurrentPage(parseInt(pageParam, 10));
    }
  }, [location.search]);

  return (
    <>
      {currentItems?.length > 0 ? (
        <div className="">
          {currentItems?.map((item, index) => (
            <div
              className="relative cursor-pointer"
              // onClick={() => navigate(`/order-details/${item?.order_id}`)}
              key={index}>
              <OrderDetailsItems key={index} data={item} />
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center md:space-y-8 space-y-4 md:mt-16 mt-10">
          <div className="md:w-40 md:h-40 w-28 h-28 rounded-full bg-[#F0F9F4] overflow-hidden flex items-center justify-center ">
            <div className="text-[#e73737] md:text-8xl text-6xl">
              <i className="fa-regular fa-bag-shopping"></i>
            </div>
          </div>
          <div className="text-cape-cod lg:text-3xl md:text-2xl text-xl text-center">
            You have no {title} orders yet.
          </div>
          <div className="text-concord text-base max-w-md text-center">
            You don’t have any products in the {title} list yet.
          </div>
        </div>
      )}
      {data?.length > 0 && (
        <Pagination
          totalItems={data?.length}
          itemsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default MyCurrentOrdersDetails;
